import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { useAuthStore } from '@/entities/auth';
import { useSession } from '@/features/session';

/**
 * Guard для инициализации сессии пользователя
 * Должен выполняться первым в цепочке guards
 */
export const sessionGuard = async (to: RouteLocationNormalized): Promise<NavigationGuardReturn> => {
  const requiresAuth = to.meta.requiresAuth ?? true;
  if (!requiresAuth) {
    return true;
  }

  const authStore = useAuthStore();
  const { initializeSession, status } = useSession();

  // Если уже загружен полный контекст - пропускаем
  if (authStore.user && authStore.currentOrganization) {
    return true;
  }

  // Если уже проверили контекст - пропускаем дальнейшую загрузку
  // (authGuard и organizationGuard обработают редиректы)
  if (authStore.isContextChecked) {
    return true;
  }

  // Первая загрузка - пытаемся загрузить контекст
  await initializeSession();

  // При transient/fatal failure оставляем navigation pending (never-resolving promise):
  // root error state показывает recovery action, а повторная навигация после retry продолжит flow.
  if (status.value === 'error') {
    return new Promise(() => {});
  }

  return true;
};
